import React from 'react';
import _ from 'lodash';
import { array, bool } from 'prop-types';
import { STATIC_DIV_LIMIT } from '../../constants/defaults';

const MemberHistory = ({ transactions, showStaticDiv }) => {
  let staticArray = [];
  if (showStaticDiv) {
    const staticArrLength = STATIC_DIV_LIMIT - transactions.length;
    for (let i = 0; i < staticArrLength; i++) {
      staticArray.push(i);
    }
  }
  return (
    <>
      {_.map(transactions, (transaction, key) => {
        const { transactionTime, eventDescription, credit } = transaction;
        const isPositive = Math.sign(credit) === 1 ? true : false;
        return (
          <div key={key} className="tableBody">
            <div className="desktop-only">
              {transactionTime &&
                _.getFormattedDate(transactionTime, 'MM/dd/yyyy')}
            </div>
            <div>
              <span className="tableDate mobile-only">
                {transactionTime &&
                  _.getFormattedDate(transactionTime, 'MM/dd/yyyy')}
              </span>
              <span className="actionStatus">
                <span className="statusLabel">
                  {eventDescription.split(' - ')[0]}
                </span>
                {eventDescription.split(' - ').length > 1 && (
                  <span className="desktop-only">&nbsp;-&nbsp;</span>
                )}
                <span className="statusValue">
                  {eventDescription.split(' - ')[1]}
                </span>
              </span>
            </div>
            <div className={`${isPositive ? 'plusValue' : 'minusValue'}`}>
              <span>{isPositive ? '+' : '-'}$</span>
              {Number(Math.abs(credit)).toFixed(2)}
            </div>
          </div>
        );
      })}
      {showStaticDiv &&
        _.map(staticArray, (item, key) => {
          return <div key={key} className="tableBody"></div>;
        })}
    </>
  );
};

MemberHistory.propTypes = {
  transactions: array,
  showStaticDiv: bool
};

MemberHistory.defaultProps = {
  transactions: [],
  showStaticDiv: false
};

export default MemberHistory;
